import type { ReactElement } from 'react';
import { motion } from 'framer-motion';
import { DONUT_TRACK_WIDTH } from './piechart-constants';
import type { PieChartArc, PieChartHoverChange } from './piechart-types';
interface PieChartArcLayersProps {
    arcs: ReadonlyArray<PieChartArc>;
    centerX: number;
    centerY: number;
    hoveredIndex: number | null;
    onHoveredIndexChange: PieChartHoverChange;
    pieChartIdPrefix: string;
}
export function PieChartArcLayers({ arcs, centerX, centerY, hoveredIndex, onHoveredIndexChange, pieChartIdPrefix, }: PieChartArcLayersProps): ReactElement {
    return (<>
      <PieChartGlowArcLayer arcs={arcs} centerX={centerX} centerY={centerY} hoveredIndex={hoveredIndex} pieChartIdPrefix={pieChartIdPrefix}/>
      <PieChartSharpArcLayer arcs={arcs} centerX={centerX} centerY={centerY} hoveredIndex={hoveredIndex} onHoveredIndexChange={onHoveredIndexChange} pieChartIdPrefix={pieChartIdPrefix}/>
    </>);
}
function PieChartGlowArcLayer({ arcs, centerX, centerY, hoveredIndex, pieChartIdPrefix, }: Omit<PieChartArcLayersProps, 'onHoveredIndexChange'>): ReactElement {
    return (
      <g filter={`url(#${pieChartIdPrefix}-glow)`}>
      {arcs.map((arc, index) => (<motion.path key={arc.debugIdentity} d={arc.pathData} fill="none" stroke={`url(#${pieChartIdPrefix}-gradient-${index})`} strokeWidth={DONUT_TRACK_WIDTH} strokeLinecap="round" initial={{ pathLength: 0, opacity: 0 }} animate={{
                pathLength: 1,
                opacity: hoveredIndex == null || hoveredIndex === index ? 0.55 : 0,
                scale: hoveredIndex === index ? 1.04 : 1,
            }} transition={{
                pathLength: { duration: 0.8, ease: [0.4, 0, 0.2, 1], delay: index * 0.08 },
                opacity: { duration: 0.2 },
                scale: { type: 'spring', stiffness: 400, damping: 25 },
            }} style={{ transformOrigin: `${centerX}px ${centerY}px` }}/>))}
      </g>
    );
}
function PieChartSharpArcLayer({ arcs, centerX, centerY, hoveredIndex, onHoveredIndexChange, pieChartIdPrefix, }: PieChartArcLayersProps): ReactElement {
    return (
      <g>
      {arcs.map((arc, index) => (<motion.path key={arc.debugIdentity} d={arc.pathData} fill="none" stroke={`url(#${pieChartIdPrefix}-gradient-${index})`} strokeWidth={DONUT_TRACK_WIDTH} strokeLinecap="round" initial={{ pathLength: 0, opacity: 0 }} animate={{
                pathLength: 1,
                opacity: hoveredIndex == null || hoveredIndex === index ? 1 : 0.25,
                scale: hoveredIndex === index ? 1.04 : 1,
            }} transition={{
                pathLength: { duration: 0.8, ease: [0.4, 0, 0.2, 1], delay: index * 0.08 },
                opacity: { duration: 0.2 },
                scale: { type: 'spring', stiffness: 400, damping: 25 },
            }} onMouseEnter={() => onHoveredIndexChange(index)} onMouseLeave={() => onHoveredIndexChange(null)} style={{ cursor: 'default', transformOrigin: `${centerX}px ${centerY}px` }}/>))}
      </g>
    );
}
